// UrlPopupLoader.js
import { connect } from 'react-redux';
import loadUrlPopup from '../action/loadUrlPopup.js';
import UrlLoader from '../component/UrlLoader.jsx';

const mapDispatchToProps = dispatch => {
  return {
    urlHandler: ({ url }) => dispatch(loadUrlPopup({ url })),
  };
};

export default connect(null, mapDispatchToProps)(UrlLoader);
